module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LA-c2b7ca2a588aa1169fef69b0aa26adb1.png";